/**
 * Initializing of carousels
 */

import Flickity from 'flickity-bg-lazyload';

// General carousel settings
const carouselSettings = {
	arrowShape: 'M60.9,77.5l-2.4-0.7l-27.8-24c-1.4-1.4-1.7-3.5-0.3-4.9l0.3-0.3l27.8-24c1.3-1.3,3.4-1.5,4.9-0.3c1.3,1.3,1.5,3.4,0.3,4.9l-0.7,0.7L38.4,50l24.7,21.2c1.4,1.2,1.7,3.3,0.7,4.9C63.1,77,62.1,77.5,60.9,77.5L60.9,77.5z',
	productCarousels() {
		return {
			arrowShape: this.arrowShape,
			cellSelector: '.product',
			cellAlign: 'left',
			pageDots: false,
			wrapAround: true,
		};
	},
	productCarouselsRelated() {
		return {
			arrowShape: this.arrowShape,
			cellSelector: '.product',
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			groupCells: true,
		};
	},
};

/**
 * Hero Carousel initialized
 */
if ( document.getElementsByClassName( 'hero-carousel' ).length ) {
	const heroFlkty = new Flickity( '.hero-carousel', { // eslint-disable-line no-unused-vars
		adaptiveHeight: true,
		wrapAround: true,
		bgLazyLoad: 1,
		arrowShape: carouselSettings.arrowShape,
		on: {
			ready() {
				window.dispatchEvent( new Event( 'resize' ) );
			},
		},
	} );
}

/**
 * New Products Carousel initialized
 */
if ( document.querySelector( '.archive .new-products-carousel' ) ) {
	// if we are on an archive page
	const newProductFlkty = new Flickity( '.new-products-carousel .products', carouselSettings.productCarouselsRelated() ); // eslint-disable-line no-unused-vars
} else if ( document.querySelector( '.home .new-products-carousel' ) ) {
	// if we are on the startpage
	const newProductFlkty = new Flickity( '.new-products-carousel .products', carouselSettings.productCarousels() ); // eslint-disable-line no-unused-vars
}

/**
 * Bestselling Products Carousel initialized
 */
if ( document.querySelector( '.archive .bestselling-products-carousel, .single-product .bestselling-products-carousel' ) ) {
	// if we are on an archive page or single-product page
	const newProductFlkty = new Flickity( '.bestselling-products-carousel .products', carouselSettings.productCarouselsRelated() ); // eslint-disable-line no-unused-vars
} else if ( document.querySelector( '.home .bestselling-products-carousel' ) ) {
	// if we are on the startpage
	const bestProductFlkty = new Flickity( '.bestselling-products-carousel .products', carouselSettings.productCarousels() ); // eslint-disable-line no-unused-vars
}

/**
 * Bundle Products Carousel initialized
 */
if ( document.getElementsByClassName( 'bundle-products-carousel' ).length ) {
	const bundleProductFlkty = new Flickity( '.bundle-products-carousel .products', carouselSettings.productCarousels() ); // eslint-disable-line no-unused-vars
}

/**
 * Related Products Carousel initialized
 */
if ( document.getElementsByClassName( 'related' ).length ) {
	const relatedProductFlkty = new Flickity( '.related .products', carouselSettings.productCarouselsRelated() ); // eslint-disable-line no-unused-vars
}

/**
 * Cross sells Products Carousel initialized
 */
if ( document.getElementsByClassName( 'cross-sells' ).length ) {
	const crossSellsProductFlkty = new Flickity( '.cross-sells .products', carouselSettings.productCarouselsRelated() ); // eslint-disable-line no-unused-vars
}

/**
 * Category Carousel initialized
 */
if ( document.getElementsByClassName( 'category-carousel' ).length ) {
	const categoryFlkty = new Flickity( '.category-carousel .carousel', { // eslint-disable-line no-unused-vars
		cellSelector: '.carousel-cell',
		cellAlign: 'left',
		arrowShape: carouselSettings.arrowShape,
		wrapAround: true,
		pageDots: false,
	} );
}

/**
 * SIUS Blog Carousel initialized
 */
if ( document.getElementsByClassName( 'blog-carousel' ).length ) {
	const categoryFlkty = new Flickity( '.blog-carousel .carousel', { // eslint-disable-line no-unused-vars
		cellSelector: '.carousel-cell',
		cellAlign: 'left',
		arrowShape: carouselSettings.arrowShape,
		pageDots: false,
		watchCSS: true,
		wrapAround: true,
	} );
}
